import React from "react";

/**
 * Circular Girone badge using the official PNG icons (public/girone-{a|b|c|d}.png).
 * Falls back to the letter if the girone isn't A/B/C/D.
 */
export default function GironeBadge({ girone, size = 40, className = "", title }) {
  const g = String(girone || "").trim().toUpperCase();
  const valid = ["A", "B", "C", "D"].includes(g);
  if (!valid) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full bg-slate-200 text-slate-700 font-black ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.5 }}
        aria-label={`Girone ${g || "?"}`}
        data-testid={`girone-badge-${g || "unknown"}`}
      >
        {g || "?"}
      </span>
    );
  }
  return (
    <img
      src={`/girone-${g.toLowerCase()}.png`}
      alt={`Girone ${g}`}
      title={title || `Girone ${g}`}
      className={`inline-block object-contain shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid={`girone-badge-${g}`}
    />
  );
}
